<template>
  <section class="settings-card">
    <header class="settings-card__header">
      <div class="settings-card__heading">
        <span class="settings-card__icon">
          <slot name="icon" />
        </span>

        <div>
          <h2>{{ title }}</h2>
          <p>{{ description }}</p>
        </div>
      </div>
    </header>

    <div
      class="settings-card__body">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'SettingsCard',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/dashboardCards.scss';

.settings-card {
  @include dashboard-card;

  &__body {
    padding: 0 24px 24px;
  }

  @media (max-width: 768px) {
    &__body {
      padding: 0 16px 16px;
    }
  }
}
</style>
